/**
 * Eine Mail als `.eml` speichern (User 26.10.2026: „neben Drucken auch ein
 * Runterladen"). Der Dateiname kommt aus dem Betreff — Windows verbietet
 * `\ / : * ? " < > |`, und ein Name aus lauter Leerzeichen hilft niemandem.
 */
export function mailDateiname(betreff: string | null | undefined): string {
    const name = (betreff ?? "")
        .replace(/[\\/:*?"<>|\u0000-\u001f]/g, " ")
        .replace(/\s+/g, " ")
        .trim()
        .slice(0, 120)
        .replace(/[. ]+$/, "");
    return `${name || "Mail"}.eml`;
}

/** Blob als Datei speichern. Die URL lebt noch kurz weiter — Safari bricht sonst ab. */
export function speichereMail(blob: Blob, betreff: string | null | undefined): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = mailDateiname(betreff);
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 30_000);
}
